import { buildPostFromAggregator } from "./post_helper";
import * as Sentry from "@sentry/browser";

let aggregatorURL = import.meta.env.VITE_AGGREGATOR_URL;
if (import.meta.env.DEV && aggregatorURL === undefined) {
  aggregatorURL = "http://localhost:3300";
}

async function fetchPostsForCategory(id, aggregatorKey) {
  const url = new URL(
    id
      ? `${aggregatorURL}/edubox/posts/${encodeURIComponent(id)}`
      : `${aggregatorURL}/edubox/posts`,
  );

  const response = await fetch(url, {
    headers: {
      Authorization: `token ${aggregatorKey}`,
    },
  });

  if (!response.ok) {
    throw new Error(`Error: ${response.status} - ${response.statusText}`);
  }

  const payload = await response.json();

  return Array.isArray(payload)
    ? payload.map((item) => buildPostFromAggregator(item))
    : [];
}

export default async function fetchPosts(id, category) {
  try {
    if (!category.aggregatorKey) {
      throw new Error(`Missing aggregator key for category "${category.slug}"`);
    }
    return await fetchPostsForCategory(id, category.aggregatorKey);
  } catch (err) {
    if (import.meta.env.DEV) {
      // We log errors in console only in dev
      // eslint-disable-next-line no-console
      console.error(err);
    } else {
      Sentry.captureException(err);
    }
  }
}
